import { render, staticRenderFns } from "./VariantPicker.vue?vue&type=template&id=0085bdd4"
import script from "./VariantPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariantPicker.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports